// extracted by mini-css-extract-plugin
export default {"intro":"GameShowcaseForm_intro__IS7Mv","benefits":"GameShowcaseForm_benefits__OhlW1"};